module.exports = __webpack_public_path__ + "static/media/gred-image3@3x.68c48ca0.png";